import _isNumber from 'lodash/isNumber';

export default function getCustomRuleTitle(position) {
  const title = 'Recommended Product';
  if (!_isNumber(position)) return title;
  return `${title} ${position}`;
}
